import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

interface RatingRow { star: number; count: number; pct: number; }

/**
 * Star-rating breakdown bars (mockup review distribution). Input `counts` is a length-5
 * array where index i holds the (i+1)-star count — matching the mockup's `ratingBreakdown`
 * (`c[rating-1]++`). Rows render 5→1; bar width = count / max(count).
 */
@Component({
  selector: 'app-rating-bars',
  standalone: true,
  styleUrl: './rating-bars.component.scss',
  imports: [CommonModule],
  templateUrl: './rating-bars.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingBarsComponent {
  private readonly _counts = signal<number[]>([0, 0, 0, 0, 0]);
  @Input() set counts(v: number[]) { this._counts.set(v ?? [0, 0, 0, 0, 0]); }

  readonly rows = computed<RatingRow[]>(() => {
    const c = this._counts();
    const max = Math.max(1, ...c);
    return [5, 4, 3, 2, 1].map(star => {
      const count = c[star - 1] ?? 0;
      return { star, count, pct: Math.round((count / max) * 100) };
    });
  });
}
